export default "__VITE_ASSET__06a4285b__"